import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent {
  constructor(private bsModalRef: BsModalRef, private _api: ApiService) { }

  onClose() {
    this.bsModalRef.hide();
  }
  
}
